module.exports = __webpack_public_path__ + "img/1.3.c0b283d4.png";